import Component from '../core/Component'
import { queries } from '../core/config'
import enquire from 'enquire.js'
import Flickity from 'flickity'

const STATES = {
    ACTIVE: 'is-active'
}

const defaults = {
    media: null
}

export default class PointSlider extends Component {
    constructor(element) {
        super(element, defaults)

        this.ref = {
            list: null,
            items: [],
            current: null,
            progress: null
        }

        this.flickity = null
        this.duration = 4000
        this.timer = null
        this.isRunning = false

        this.enquireHandler = null

        if (this.options.media) {
            this.options.media = queries[this.options.media] || this.options.media
            this.enquireHandler = {
                match: this.attach,
                unmatch: this.detach
            }
        }
    }

    prepare() {
        if (this.options.media) {
            enquire.register(this.options.media, this.enquireHandler)
        } else {
            this.attach()
        }
    }

    destroy() {
        if (this.options.media) {
            enquire.unregister(this.options.media, this.enquireHandler)
        }
        this.detach()
    }

    attach = () => {
        this.flickity = new Flickity(this.ref.list, {
            cellSelector: '[data-ref="item"]',
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false
        })

        this.flickity.on('change', this.handleChange)
        this.flickity.on('dragStart', this.handleDragStart)
        this.flickity.on('dragEnd', this.handleDragEnd)
        this.flickity.on('settle', this.handleSettle)
        this.flickity.on('scroll', this.handleScroll)

        this.start()
    }

    detach = () => {
        if (this.flickity) {
            this.flickity.destroy()
            this.flickity = null
        }
        this.ref.progress.classList.remove(STATES.ACTIVE)
        this.stop()
    }

    handleChange = index => {
        this.ref.current.textContent = index + 1
        if (this.isRunning) {
            this.ref.progress.classList.remove(STATES.ACTIVE)
            this.ref.progress.offsetWidth
            this.ref.progress.classList.add(STATES.ACTIVE)
        }
    }

    handleDragStart = event => {
        this.ref.progress.classList.remove(STATES.ACTIVE)
        this.stop()
    }

    handleDragEnd = event => {

    }

    handleSettle = () => {
        if (!this.isRunning) {
            this.ref.progress.classList.remove(STATES.ACTIVE)
            this.ref.progress.offsetWidth
            this.ref.progress.classList.add(STATES.ACTIVE)
            this.start()
        }
    }

    start() {
        this.isRunning = true
        this.ref.progress.classList.add(STATES.ACTIVE)
        clearInterval(this.timer)
        this.timer = setInterval(this.next, this.duration)
    }

    stop() {
        this.isRunning = false
        clearInterval(this.timer)
    }

    next = () => {
        this.flickity?.next()
    }
}
